import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal from 'flarum/common/components/Modal';

import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

export default class TermsConditionsModal extends Modal {
  // True by default, dictates whether the modal can be dismissed by clicking on the background or in the top right corner.
  static isDismissible = false;

  oninit(vnode) {
    super.oninit(vnode);
    this.accepted = false;
    this.processing = false;
  }

  className() {
    // Custom CSS classes to apply to the modal
    return 'Modal';
  }

  title() {
    // Content to show in the modal's title bar
    return <span>Terms of Use</span>;
  }

  content() {
    // Content to show in the modal's body
    return (
      <form onsubmit={this.onsubmit.bind(this)}>
        <div className="FormFieldWrap mb-2 px-2">
          <div>
            <div className="FormFieldWrap mt-2">
              <input
                type="checkbox"
                oninput={(e) => {
                  this.accepted = e.target.checked;
                }}
              />{' '}
              I agree to{' '}
              <a href="/p/1-terms-of-use" target="_blank">
                The Desktop Forum's Terms of Use
              </a>{' '}
              which have been designed to create a respectful, fun and informative environment.
            </div>

            <div className="FormFieldWrap mt-2">
              <div className="FormGroup d-flex justify-content-between">
                {this.processing ? (
                  LoadingIndicator.component()
                ) : (
                  <Button type="submit" className="Button Button--primary" disabled={this.processing || !this.accepted}>
                    Proceed
                  </Button>
                )}

                {Button.component(
                  {
                    onclick: app.session.logout.bind(app.session),
                    className: 'Button',
                  },
                  app.translator.trans('core.forum.header.log_out_button')
                )}
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }

  createCookie(name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = '; expires=' + date.toGMTString();
    } else var expires = '';
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  onsubmit(e) {
    app.alerts.clear();
    e.preventDefault();
    this.processing = true;
    this.createCookie('loggedIn', 'true', '9999');
    app.modal.close(TermsConditionsModal);
    window.location.reload();
    /* app
      .request({
        method: 'POST',
        url: '/api/lesson-plans/suggest',
        body: { data: this.form },
      })
      .then(function (response) {
        app.alerts.show({ type: 'success' }, 'Thank you!');
        thisClass.processing = false;
        app.modal.close(thisClass);
      })
      .catch(function (e) {
        thisClass.processing = false;
      }); */
  }
}
